'use strict';

const Base = require('components/Base/Base');
const _ = require('underscore');
const Events = require('constants/Events');
const Constants = require('constants/Constants');
require('svg4everybody');

require('./Page.less');

const BindFunctions = [
    'onScroll',
    'onResize',
    'onPageLoaded',
    'detectResize',
    'onStartPlay',
    'setLazyLoading'
];

module.exports = Base.extend({

    el: 'body',

    events: {},

    initialize: function (options = {}) {
        _.extend(this, options);
        _.bindAll(this, BindFunctions);

        this.isPhone = window.app.settings.isPhone && window.matchMedia('(max-width: 767px)').matches;
        this.prevWh = 0;

        //пробегаемся по всем секционным блокам страницы
        // this.$('.js-sequence').each((ind1, section) => {
        //     const imagesToWait = [];
        //
        //     //бежим по каждому элементу внутри секции
        //     //и вытаскиваем картинки которые они используют
        //     $('*', section).each((ind2, item) => {
        //         if (item.tagName.toLowerCase() === 'img') {
        //             imagesToWait.push(item);
        //         }
        //     });
        //
        //     //прописываем секции сколько в ней элементов загрузки которых надо ждать
        //     $(section).attr('data-load-count', imagesToWait.length);
        //
        //     imagesToWait.forEach((img) => {
        //         let loader = new Image;
        //         loader.crossOrigin = '';
        //         const imgSrc = $(img).data('src');
        //
        //         img.onload = () => {
        //             $(section).attr('data-load-count', $(section).attr('data-load-count') - 1);
        //
        //             if (+$(section).attr('data-load-count') === 0) {
        //                 this.sequenceImagesLoaded(); // ones images loaded
        //             }
        //             img.onload = null;
        //             img = null;
        //         };
        //
        //         img.src = imgSrc;
        //     });
        //
        //     !imagesToWait.length && this.sequenceImagesLoaded();
        // });

        app.vent.on(Events.home.hero.videoSequenceLoaded, this.onStartPlay);
        app.vent.on(Events.common.pageLoaded, this.onPageLoaded);

        Base.prototype.initialize.call(this, options);
    },

    onStartPlay: function () {
        this.detectResize();
    },

    onPageLoaded: function () {
        this.detectResize();
    },

    sequenceImagesLoaded: function () {
        app.vent.trigger(Events.common.sequenceImagesLoaded);
    },

    onResize: function () {
        const scrollTop = app.els.$window
            .scrollTop();

        this.isPhone = window.app.settings.isPhone && window.matchMedia('(max-width: 767px)').matches;

        this.$el.css(Constants.cssProperties.opacity, 1);

        this.wh = app.els.$window.innerHeight();

        if (this.wh === this.prevWh && this.isPhone) {
            return;
        }

        this.animatedBlocks = _.map(this.$(Constants.selectors.isInitialState), (block) => {
            return {
                $el: $(block),
                offsetTop: block.getBoundingClientRect().top + scrollTop,
                height: $(block).innerHeight(),
                isAnimated: false,
                isImmediateShow: $(block).hasClass(Constants.cssClasses.isImmediateShow),
                viewName: $(block).closest('section, header, footer')
                    .data('view')
            };
        });

        this.onScroll(app.els.$window.scrollTop());

        this.prevWh = this.wh;
    },

    onScroll: function (scrollTop) {
        if (!this.animatedBlocks) {
            return;
        }

        this.animatedBlocks.forEach((block) => {
            if (block.isAnimated) {
                return;
            }

            if (app.settings.isIE) {
                block.$el
                    .removeClass(Constants.cssClasses.isInitialState)
                    .addClass(Constants.cssClasses.isSectionShown);

                block.isAnimated = true;

                this.sectionShown(block.viewName, block.$el);

                return;
            }

            if (block.isImmediateShow) {
                this.setLazyLoading(block.$el);

                block.$el
                    .removeClass(Constants.cssClasses.isInitialState);

                setTimeout(() => {
                    block.$el.addClass(Constants.cssClasses.isSectionShown);
                    block.isAnimated = true;
                }, 1000);

                this.sectionShown(block.viewName, block.$el);

                return;
            }

            let topPosition = scrollTop;

            if (block.height >= this.wh / 100 * 75) {
                topPosition += (this.wh / 100 * 70);
            } else {
                // topPosition += (this.wh - block.height / 1.5);
                topPosition += (this.wh - 150); // 100 - 150 px specified
            }

            topPosition = (!window.app.settings.isMobile) ? topPosition : scrollTop + this.wh - 100;

            if ((block.offsetTop < topPosition) && (block.offsetTop + block.height > scrollTop)) {
                this.setLazyLoading(block.$el);

                block.$el.removeClass(Constants.cssClasses.isInitialState);
                block.isAnimated = true;

                this.sectionShown(block.viewName, block.$el);

                setTimeout(() => {
                    block.$el.addClass(Constants.cssClasses.isSectionShown);
                    block.isAnimated = true;
                }, 1000);
            }
        });
    },

    setLazyLoading: function (section) {
        section.find('[data-lazy]').each((id, item) => {
            const $item = $(item);
            const src = $item.data('src');

            $item[0].src = src;
        });
    },

    detectResize: function () {
        setTimeout(() => {
            app.els.$window.scrollTop(0);

            const resizeStarted = () => {
                app.vent.trigger(Events.common.resizeStarted);
            };

            const resizeEnded = () => {
                app.vent.trigger(Events.common.resizeEnded);
            };

            const resizeStartedDebounced = _.debounce(resizeStarted, 500, true);
            const resizeEndedDebounced = _.debounce(resizeEnded, 500);
            const onResizeThrottled = _.throttle(this.onResize, 16.6666666 * 8);
            const onScrollThrottled = _.throttle(this.onScroll, 16.6666666 * 8);

            app.vent
                .on(Events.common.resize, () => {
                    resizeStartedDebounced();
                    resizeEndedDebounced();
                    onResizeThrottled();
                })
                .on(Events.common.scroll, onScrollThrottled);

            //reinit
            app.vent.trigger(Events.common.resizeStarted);
            app.vent.trigger(Events.common.resizeEnded);

            //proceed resize and scroll with throttle
            onResizeThrottled();
        }, app.settings.isDesktop ? 200 : 1000);
    }
});
